/* eslint-disable */
import * as React from 'react';
import Dialog from '@mui/material/Dialog';

import { DialogContent, Divider, Grid, Paper, useTheme } from '@mui/material';
import { gridSpacing } from 'store/constant';
import { useNavigate } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useGetMachineById } from 'hooks/useMachineHooks';
import styled from '@emotion/styled';

import { useSelector } from 'react-redux';
import MachineViewModalSkeleton from 'ui-component/cards/Skeleton/MachineViewModalSkeleton';
import { useEffect } from 'react';
// Section Components
import MachineHeader from './MachineModalComponents/MachineHeader';
import OrganizationCard from './MachineModalComponents/OrganizationCard';
import MachineBinThreshold from './MachineModalComponents/MachineBinThreshold';
import MachineSubscription from './MachineModalComponents/MachineSubscription';
import MachineLocation from './MachineModalComponents/MachineLocation';
import MachineInformation from './MachineModalComponents/MachineInformation';
import MachineInvoice from './MachineModalComponents/MachineInvoice';
import MachineConfiguration from './MachineModalComponents/MachineConfiguration';
import MachineActions from './MachineModalComponents/MachineActions';

export default function MachineModalDialog({
  open,
  setOpen,
  openLeaseMachineModal,
  setOpenLeaseMachineModal,
  urlSingle,
  urlAddBatch,
  toggleBoughtRentedAssigned,
  details,
  callFrom,
  setOpenRejectModal
}) {
  const sectionRef = React.useRef(null);
  // console.log('🚀 ~ details:', details);
  const location = useLocation();
  const queryParams = new URLSearchParams(location?.search);
  const viewMachineID = queryParams?.get('viewMachineID');
  const viewSub = queryParams?.get('viewSub');
  // console.log('viewSub', viewSub);

  details = {
    ...details,
    id: open.machineId ? open.machineId : viewMachineID
  };
  const { data: machineDetailsArr, isLoading: isLoadingMachine } = useGetMachineById({
    id: open.machineId
  });
  const machineDetails = machineDetailsArr?.machine;
  // console.log('🚀 ~ machineDetails :', machineDetails);
  const machinePermission = machineDetailsArr?.permission;
  const machineSubscriptionleftTimeText = machineDetailsArr?.leftTimeText;
  // console.log('🚀 ~ machinePermission:', machinePermission);

  // Update state when API data loads

  const orgType = useSelector((state) => state?.customization?.orgType);
  const handleClose = () => {
    setOpen((state) => ({ ...state, open: !state.open, machineId: null }));
  };
  const navigate = useNavigate();
  const theme = useTheme();
  const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.h4,
    padding: '10px'
  }));

  const stepsLoading = ['Select master blaster campaign settings', 'Create an ad group', 'Create an ad'];

  const RecyclerToggleBoughtRentedAssignedCondition =
    (orgType === 'Recycler' && toggleBoughtRentedAssigned === 'Assigned') || orgType === 'Service Provider';
  // console.log(
  //   'toggleBoughtRentedAssigned | View Modal : ',
  //   toggleBoughtRentedAssigned,
  //   orgType,
  //   orgType === 'Recycler' && toggleBoughtRentedAssigned === 'Assigned',
  //   RecyclerToggleBoughtRentedAssignedCondition
  // );

  useEffect(() => {
    // console.log('sectionRef - useEffect', sectionRef, sectionRef.current);
    if (viewMachineID && Boolean(viewSub)) {
      setTimeout(() => {
        if (sectionRef.current) {
          sectionRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'start' // 'center' or 'end' can be used as well
          });
        }
      }, 10); // Adjust the delay if necessary
    }
  }, [viewSub]);

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={'xl'} // Set this to "xs" to make the dialog smaller
        onClose={handleClose}
        open={open.open}
      >
        <MachineHeader
          machineDetails={machineDetails}
          isLoadingMachine={isLoadingMachine}
          handleClose={handleClose}
          machinePermission={machinePermission}
          setOpenRejectModal={setOpenRejectModal}
          open={open}
        />
        {/* <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500]
          })}
        >
          <CloseIcon color="error" />
        </IconButton> */}
        <Divider />
        <DialogContent
          dividers
          className="choose_option_modal"
          style={{
            padding: '8px 16px', // Reduce padding to make the dialog more compact
            boxShadow: 'unset',
            border: 'unset'
          }}
        >
          {isLoadingMachine ? (
            <>
              <MachineViewModalSkeleton />
            </>
          ) : (
            <>
              <OrganizationCard
                machineDetails={machineDetails}
                RecyclerToggleBoughtRentedAssignedCondition={RecyclerToggleBoughtRentedAssignedCondition}
              />

              {/* Machine Bin Threshold */}
              {machinePermission?.showBinThresholdButton && (
                <MachineBinThreshold machineDetails={machineDetails} setOpen={setOpen} theme={theme} />
              )}

              {/* Machine Subscription Section */}
              {machinePermission?.showAddSubs && (
                <Grid ref={sectionRef} container spacing={gridSpacing} style={{ paddingTop: '30px' }}>
                  <MachineSubscription
                    machineDetails={machineDetails}
                    machineSubscriptionleftTimeText={machineSubscriptionleftTimeText}
                    isLoading={isLoadingMachine}
                    open={open}
                    setOpen={setOpen}
                    callFrom={callFrom}
                  />
                </Grid>
              )}

              {/* Machine Location Section */}
              <MachineLocation machineDetails={machineDetails} />

              {/* Machine Information Section */}
              <MachineInformation machineDetails={machineDetails} />

              {/* Machine Invoice Invoice  */}
              <MachineInvoice machineDetails={machineDetails} />

              {/* Machine Configuration Section  */}
              {machinePermission?.showMachineConfig && (
                <>
                  <MachineConfiguration machineDetails={machineDetails} />
                </>
              )}
              {/* Machine Stepper  */}
              {/* <Grid container spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <MachineStepper />
                </Grid>
              </Grid> */}
            </>
          )}

          {/* Raise Ticket | View Ticket | Rent Machine - Buttons */}
          <MachineActions machineDetails={machineDetails} open={open} setOpen={setOpen} machinePermission={machinePermission} />
        </DialogContent>
      </Dialog>
    </>
  );
}
